import { useState } from "react";
import { OfficerNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/OfficerNameCommanDDL";
import { useTranslation } from "react-i18next";

const ActionPopup = ({ handleAction, deleteRecord, message, heading, TitleFlag }) => {
    // DDL

    const { t } = useTranslation()

    const [RadioDwarfism, setRadioDwarfism] = useState(false)


    return (<>
        <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content p-3">
                    <div className="modal-header pt-0">

                        <h5 className="card-title fw-bold" id="exampleModalLongTitle">{TitleFlag}</h5>
                        <button onClick={() => handleAction()} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="row " >
                                <div class="col-12 col-lg-6 pt-3">
                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.EmployeeName')}</label><br />

                                    <OfficerNameCommanDDL />
                                </div>

                                <div class="col-12 col-lg-6 pt-3">
                                    <label for="fname" className=" pb-2">{t('EncroachmentDashboard.Remark')}</label><br />
                                    <input type="text" placeholder="" name="email" className="form-control" id="email" required />

                                </div>

                                <div class="col-12 col-lg-12 pt-3 mt-3">

                                    <input type="checkbox"
                                        onChange={() => setRadioDwarfism(!RadioDwarfism)}
                                        id="vehicle1" name="vehicle1" value="Bike" />
                                    <label className="ps-3 fw-bold" for="vehicle1"> तुम्हाला तक्रार  {TitleFlag}  करायची आहे का ? </label><br />
                                </div>

                                {

                                    RadioDwarfism ?


                                        <div className="row">


                                            <div className="col-12 col-lg-6 pt-2 ps-5">
                                                {/* <span className="">Plants Growth  : </span> */}
                                                <input
                                                    type="file"
                                                    className="form-control mt-2 "
                                                    name="DepartmentName"
                                                    placeholder="value"

                                                />
                                            </div>
                                            <div className="col-12 col-lg-6 pt-4 cursor-pointer">
                                             <i class="fa-solid fa-eye"></i>
                                            </div>
                                        </div>

                                        :
                                        ''
                                }
                            </div>

                            <div className="row">
                                <div className="col-12 pt-3 text-center">
                                    <div className="justify-content-between">
                                        <button
                                            type='button'
                                            onClick={() => handleAction()}
                                            className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-floppy-disk"></i> Save
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleAction}
                                            className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-xmark"></i> Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default ActionPopup;